import { Trash2, FolderOpen, BookMarked } from "lucide-react";

export const SavedSetsPanel = ({ sets, loading, onOpen, onDelete }) => {
  return (
    <aside className="hk-card-strong p-5" data-testid="saved-sets-panel">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <BookMarked size={16} color="#00BFA5" />
          <span
            className="font-display"
            style={{
              color: "#E8F0F7",
              fontSize: 18,
              fontWeight: 700,
              letterSpacing: "0.01em",
            }}
          >
            Saved Sets
          </span>
        </div>
        <span
          className="font-mono"
          style={{ color: "#7A9BB5", fontSize: 11, letterSpacing: "0.1em" }}
          data-testid="saved-sets-total"
        >
          {sets.length} TOTAL
        </span>
      </div>

      {loading ? (
        <div className="space-y-2" data-testid="saved-sets-loading">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="hk-pulse rounded-lg"
              style={{
                background: "rgba(232,240,247,0.05)",
                height: 56,
                animationDelay: `${i * 120}ms`,
              }}
            />
          ))}
        </div>
      ) : sets.length === 0 ? (
        <div
          className="rounded-lg px-4 py-6 text-center"
          style={{
            border: "1px dashed rgba(232,240,247,0.12)",
            color: "#7A9BB5",
          }}
          data-testid="saved-sets-empty"
        >
          <div style={{ fontSize: 14 }}>No saved sets yet.</div>
          <div style={{ fontSize: 12, marginTop: 4 }}>
            Generate questions, then hit <span style={{ color: "#00BFA5" }}>Save Set</span>.
          </div>
        </div>
      ) : (
        <ul className="space-y-2" data-testid="saved-sets-list">
          {sets.map((s) => (
            <li
              key={s.id}
              className="group rounded-lg flex items-center gap-3 px-3 py-3"
              style={{
                background: "rgba(13,35,64,0.55)",
                border: `1px solid ${
                  s.is_public ? "rgba(79,142,247,0.20)" : "rgba(232,240,247,0.06)"
                }`,
              }}
              data-testid={`saved-set-${s.id}`}
            >
              <button
                type="button"
                onClick={() => onOpen(s)}
                className="flex-1 text-left min-w-0"
                data-testid={`saved-set-open-${s.id}`}
              >
                <div className="flex items-center gap-2">
                  <span
                    className="truncate"
                    style={{
                      color: "#E8F0F7",
                      fontWeight: 600,
                      fontSize: 14,
                    }}
                  >
                    {s.name}
                  </span>
                  {s.is_public && (
                    <span
                      className="hk-chip hk-chip-info"
                      style={{ fontSize: 9, padding: "1px 6px" }}
                      data-testid={`saved-set-public-${s.id}`}
                    >
                      PUBLIC
                    </span>
                  )}
                </div>
                <div
                  className="truncate"
                  style={{ color: "#7A9BB5", fontSize: 12 }}
                >
                  {s.chapterNote ? `${s.chapterNote} · ` : ""}
                  {s.questions.length} questions
                </div>
              </button>
              <button
                type="button"
                onClick={() => onOpen(s)}
                className="hk-btn-ghost px-2 py-1 text-xs"
                aria-label={`open ${s.name}`}
                data-testid={`saved-set-open-icon-${s.id}`}
              >
                <FolderOpen size={12} />
              </button>
              {!s.is_public && (
                <button
                  type="button"
                  onClick={() => onDelete(s.id)}
                  className="hk-btn-ghost px-2 py-1 text-xs"
                  style={{
                    color: "#E84040",
                    borderColor: "rgba(232,64,64,0.35)",
                  }}
                  aria-label={`delete ${s.name}`}
                  data-testid={`saved-set-delete-${s.id}`}
                >
                  <Trash2 size={12} />
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
    </aside>
  );
};

export default SavedSetsPanel;
